export const normalizeLeadRows = (rows = []) => rows.map((item) => ({
  ...item,
  updatedAt: item.udate || item.updatedAt || item.updated_at,
  taskUpdateDate: item.latestTaskUpdateDate || item.taskUpdateDate,
  taskUpdateBy: item.latestTaskUpdateById ? {
    firstName: item.latestTaskUpdateByFirstName,
    lastName: item.latestTaskUpdateByLastName,
    id: item.latestTaskUpdateById
  } : item.taskUpdateBy,
  assignedToDepartmentId: item.assignedToDepartmentId,
}));

export const getDisplayedLeads = (rows = [], isPagedResponse = false, filterByPeriod = (items) => items) => {
  if (isPagedResponse) {
    return rows;
  }

  return filterByPeriod(rows);
};